export default __webpack_public_path__ + "static/media/memories_3r2c.ca0bdffe.png";